import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { IconCheck } from '../../Icon/IconCheck';
import { InputGroupButton } from '../../InputGroupButton';
import { isEmail } from '../../../domain/utils/stringUtils';
import { newsletterApiService } from '../../../domain/services/newsletterApiService';
import { theme } from '../../../domain/theme/theme';
import { t } from '../../../domain/services/configService';
import {
  consentMgmtCheckbox,
  consentMgmtErrorMessage,
  consentMgmtLoadingImage
} from '../../Styles/consentManagement';
import { ParagraphWrapper } from '../ParagraphWrapper';

const NewsletterModuleParagraphInner = ({ data }) => {
  const [consentData, setConsentData] = useState();
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const formID = `newsletter-module-${data.id}`;
  const emailInput = useRef(null);
  const emailError = useRef(null);
  const checkboxError = useRef(null);
  const networkThreeError = useRef(null);
  const error400 = useRef(null);
  const error409 = useRef(null);
  const error428 = useRef(null);
  const error429 = useRef(null);
  const ageVerificationError = useRef(null);
  const ageVerification = true;

  const getConsent = () => {
    if (!consentData) {
      setIsLoading(true);
      newsletterApiService
        .getConsentMetadata()
        .then(response => {
          if (response.status !== 200) {
            throw new Error('error');
          }
          return response.json();
        })
        .then(consentMetadata => {
          setConsentData(consentMetadata);
          setIsLoading(false);
          setError(false);
        })
        .catch(error => {
          // oxlint-disable-next-line no-console
          console.log(error);
          setIsLoading(false);
          networkThreeError.current.style.display = 'block';
          setError(true);
        });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let errors = false;
    if (typeof document === 'object') {
      const checkboxes = document.querySelectorAll(
        `#${formID} .consent-mgmt__checkbox-input`
      );
      const textInputs = document.querySelectorAll(
        `#${formID} .consent-mgmt__text-input`
      );

      checkboxes.forEach(checkbox => {
        if (checkbox.required && !checkbox.checked) {
          checkbox.parentElement.parentElement
            .querySelector('h7')
            .classList.add('error');
          errors = true;
        } else {
          checkbox.parentElement.parentElement
            .querySelector('h7')
            .classList.remove('error');
        }
        if (checkbox.id === 'age_verification' && ageVerification) {
          const ageChallenge = FNGUserAPI.ageVerification(checkbox.checked);
          if (!checkbox.checked) {
            checkbox.parentElement.parentElement
              .querySelector('h7')
              .classList.add('error');
            errors = true;
          } else if (ageChallenge === false) {
            const inputLabel =
              checkbox.parentElement.parentElement.querySelector('h7');
            inputLabel.classList.add('error');
            ageVerificationError.current.style.display = 'block';
            errors = true;
          }
        }
      });
      textInputs.forEach((textInput, i) => {
        if (textInput.required && textInput.value === '') {
          checkboxes[i].classList.add('error');
          errors = true;
        } else {
          checkboxes[i].classList.remove('error');
        }
      });
      if (!errors && isEmail(emailInput.current.value)) {
        setIsLoading(true);
        emailError.current.style.display = 'none';
        checkboxError.current.style.display = 'none';
        networkThreeError.current.style.display = 'none';
        const form = document.getElementById(formID);
        const bodyData = {};
        [...form.elements].forEach(element => {
          if (element.name !== '') {
            if (element.type === 'checkbox') {
              bodyData[element.name] = element.checked;
            } else {
              bodyData[element.name] = element.value;
            }
          }
        });
        newsletterApiService
          .subscribe(bodyData)
          .then(response => {
            if (response.status !== 200 && response.status !== 202) {
              throw new Error(`error${response.status}`);
            }
            setIsLoading(false);
            setSuccess(true);
            setError(false);
          })
          .catch(error => {
            setIsLoading(false);
            // oxlint-disable-next-line no-console
            console.log('request failed', error.message);
            const errorMap = {
              error400: error400.current,
              error409: error409.current,
              error428: error428.current,
              error429: error429.current
            };
            [...form.elements].forEach((element, i) => {
              if (element.name !== '' && element.name !== 'email') {
                if (element.type === 'checkbox') {
                  form.elements[i].checked = bodyData[element.name];
                } else {
                  form.elements[i].value = bodyData[element.name];
                }
              }
            });
            if (errorMap[error.message]) {
              errorMap[error.message].style.display = 'block';
            } else {
              networkThreeError.current.style.display = 'block';
            }
            setError(true);
          });
      } else {
        if (errors) {
          if (
            ageVerification &&
            ageVerificationError.current.style.display === 'block'
          ) {
            checkboxError.current.style.display = 'none';
          } else {
            checkboxError.current.style.display = 'block';
          }
          setError(true);
        } else {
          checkboxError.current.style.display = 'none';
        }

        if (!isEmail(emailInput.current.value)) {
          emailError.current.style.display = 'block';
          setError(true);
        } else {
          emailError.current.style.display = 'none';
        }
      }
    }
  };
  const flexExtraStyles = `
    background: url(/images/NewsletterModule.png) no-repeat;
    background-size: cover; margin: 0 -30px;
    position: relative;
    ${!success && (consentData || error) ? 'padding-bottom: 40px;' : ''}
    ${theme.mq.tablet} {
      margin: 0;
      background: url(/images/NewsletterModuleDesktop.png) no-repeat right;
      background-size: cover;
      ${!success && (consentData || error) ? 'padding-bottom: 20px;' : ''}
    }
    .consent-mgmt__error-message {
      padding: 10px;
      background: rgba(0, 0, 0, 0.50);
      margin-bottom: 15px;
      margin-top: -45px;
      ${theme.mq.tablet} {
        margin-top: 0px;
      }
      display: none;
      span {
        display: block;
        margin-bottom: 0;
        letter-spacing: 2px;
      }
    }

  `;
  const joinH2styles = css`
    ${theme.font.family('boldWeb')};
    text-transform: uppercase;
    font-size: 16px;
    margin: 75px 0 25px 0;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 3px;
    text-align: center;
    color: #ffffff;
    ${theme.mq.tablet} {
      font-size: 18px;
      margin: 29px 0 27px 0;
    }
  `;
  const successH2Styles = css`
    ${theme.font.family('boldWeb')};
    text-transform: uppercase;
    font-size: 16px;
    margin: 20px 0 90px 0;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 3px;
    text-align: center;
    color: #ffffff;
    width: 50%;
    ${theme.mq.tablet} {
      font-size: 18px;
      margin: 20px 0 40px 0;
    }
  `;
  const loadingImgStyles = css`
    position: absolute;
    bottom: 8px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    ${theme.mq.tablet} {
      width: 10px;
    }
  `;

  const optionsRectangleStyles = css`
    width: 272px;
    position: absolute;
    height: 39px;
    bottom: 0;
    background-color: #000;
    right: 0;
    ${theme.mq.tablet} {
      height: 30px;
    }
  `;
  const optionsStyles = css`
    background-color: #000;
    margin: 0 -30px;
    color: #fff;
    padding: 27px;
    font-size: 14px;
    ${theme.font.family('regularWeb')};
    display: ${consentData || error ? 'block' : 'none'};
    a {
      color: #fff;
      text-decoration: underline;
    }
    ${theme.mq.tablet} {
      margin: 0;
    }
  `;
  return (
    <>
      {ageVerification && (
        <script
          src="https://specials.fnghub.com/ng/global/js/age-verification.js"
          async
        />
      )}
      <div
        css={css`
          margin-bottom: 30px;
        `}
      >
        <form id={formID} onSubmit={handleSubmit} noValidate>
          <div
            css={[
              css`
                display: flex;
                justify-content: center;
              `,
              css`
                ${flexExtraStyles}
              `
            ]}
          >
            <div
              css={css`
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
              `}
            >
              {!success ? (
                <>
                  <h2 css={joinH2styles}>{t('join our newsletter')}</h2>
                  <InputGroupButton
                    forwardedRef={emailInput}
                    onFocus={getConsent}
                    type="email"
                    name="email"
                    id="newsletter-email"
                    placeholder={t('Enter your email')}
                    onClick={handleSubmit}
                    label="Subscribe"
                    icon="email"
                  />
                  <div
                    ref={emailError}
                    className="consent-mgmt__error-message"
                    css={consentMgmtErrorMessage}
                  >
                    <span>{t('please enter a valid email address')}</span>
                  </div>
                </>
              ) : (
                <>
                  <span
                    css={css`
                      margin-top: 70px;
                      ${theme.mq.tablet} {
                        margin-top: 40px;
                      }
                    `}
                  >
                    <IconCheck size={40} color="white" />
                  </span>
                  <h2 css={successH2Styles}>
                    {`${t('thanks')},`}
                    <br />
                    {t(
                      'please check out your email inbox to confirm your subscription'
                    )}
                  </h2>
                </>
              )}
            </div>
            {!success && (consentData || error) && (
              <div css={optionsRectangleStyles} />
            )}
            {isLoading && (
              <img
                src="/images/ng-logo-animated.gif"
                alt="Loading"
                css={[loadingImgStyles, consentMgmtLoadingImage]}
              />
            )}
          </div>

          {!success && (
            <div css={optionsStyles}>
              {consentData &&
                Object.keys(consentData.consent.configuration).map(
                  (key, index) => {
                    const consent = consentData.consent.configuration[key];
                    const inputRequired = consent.required ? ' *' : '';
                    if (consent.type === 'checkbox') {
                      return (
                        <div
                          css={css`
                            margin-top: 16px;
                          `}
                          // oxlint-disable-next-line no-array-index-key
                          key={`consent-mgmt__${index}`}
                        >
                          <div
                            className="consent-mgmt__checkbox"
                            css={consentMgmtCheckbox}
                          >
                            <input
                              type="checkbox"
                              required={consent.required}
                              className="consent-mgmt__checkbox-input"
                              data-index={index}
                              id={key}
                              name={key}
                              value="1"
                            />
                            {/* oxlint-disable-next-line label-has-associated-control */}
                            <label htmlFor={key}>
                              <span />
                            </label>
                          </div>
                          <h7
                            css={css`
                              display: block;
                              margin-left: 42px;
                              &.error {
                                color: #fc4349;
                              }
                            `}
                            // oxlint-disable-next-line no-danger
                            dangerouslySetInnerHTML={{
                              __html: consent.text + inputRequired
                            }}
                          />
                        </div>
                      );
                    }

                    if (consent.type === 'text') {
                      return (
                        <div
                          // oxlint-disable-next-line no-array-index-key
                          key={`consent-mgmt__${index}`}
                          className="consent-mgmt__input-text"
                        >
                          <input
                            className="consent-mgmt__text-input"
                            required={consent.required}
                            type="text"
                            data-index={index}
                            id={key}
                            name={key}
                            placeholder={consent.text + inputRequired}
                          />
                        </div>
                      );
                    }

                    if (consent.type === 'info') {
                      return (
                        <div
                          // oxlint-disable-next-line no-array-index-key
                          key={`consent-mgmt__${index}`}
                          className="consent-mgmt__input-text"
                          // oxlint-disable-next-line no-danger
                          dangerouslySetInnerHTML={{
                            __html: consent.text
                          }}
                        />
                      );
                    }

                    if (consent.type === 'hidden') {
                      return (
                        <input
                          // oxlint-disable-next-line no-array-index-key
                          key={`consent-mgmt__${index}`}
                          type="hidden"
                          data-index={index}
                          id={key}
                          name={key}
                          value={consent.text}
                        />
                      );
                    }

                    return null;
                  }
                )}
              <div
                className="consent-mgmt__error-message"
                css={consentMgmtErrorMessage}
              >
                <span ref={ageVerificationError}>
                  {t("Sorry, you aren't eligible for this offer")}
                </span>
                <span ref={checkboxError}>
                  {t('please fill all required fields')}
                </span>
                <span ref={networkThreeError}>
                  {t('Network error. Please try again later.')}
                </span>
                <span ref={error400}>
                  {t('Network error. Please try again later.')}
                </span>
                <span ref={error409}>{t('User already subscribed.')}</span>
                <span ref={error428}>
                  {t(
                    'User already requested to subscribe, waiting for confirmation.'
                  )}
                </span>
                <span ref={error429}>
                  {t(
                    'User already requested to subscribe within the last 5 minutes.'
                  )}
                </span>
              </div>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

NewsletterModuleParagraphInner.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string
  }).isRequired
};

export const NewsletterModuleParagraph = ParagraphWrapper(
  NewsletterModuleParagraphInner
);
